import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { Box } from '@rsos/components/capstone/base';

interface Props {
  children?: ReactNode;
  color?: string;
  backgroundColor?: string;
  flow?: number;
  padding?: string;
}

const BannerContainer = styled(Box).attrs<Props>(
  ({ padding = '12px 20px' }) => ({
    horizontal: true,
    width: '100%',
    padding,
    borderRadius: '5px',
    align: 'stretch',
    justify: 'start',
  }),
)`
  box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.1);
`;

/**
 * Custom Banner component designed to be reusable across the application.
 * It has props that are common to all banners, such as color, background, and flow.
 */
const EventPaneBanner: React.FC<Props> = ({
  children,
  backgroundColor = 'primaryBase',
  color = 'background',
  flow = 12,
  padding,
}) => {
  return (
    <BannerContainer
      backgroundColor={backgroundColor}
      color={color}
      flow={flow}
      padding={padding}
    >
      {children}
    </BannerContainer>
  );
};

export default EventPaneBanner;
